import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from './_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import OmniSearchInput from './base/components/SearchInput.js';
import SearchFlyout from './base/components/flyout/SearchFlyout.js';
import SearchApplication from './SearchApplication.js';
import TaxonomyRenderers from './base/renderers/TaxonomyRenderers.js';
import { FlyoutDefaultResultPlugins } from './base/results/FlyoutResultPlugins.js';
import { ScreenClassProvider } from '@vp/swan';
import ErrorBoundary from './util/ErrorBoundary.js';
import * as abReader from '@vp/ab-reader';
import { SEARCH_BAR_FLYOUT_APPLICATION_NAME, HELP_CENTER_APPLICATION_NAME } from './util/constants.js';
import { QuerySuggestionsSearchInput } from './base/components/QuerySuggestionsSearchBar/QuerySuggestionsSearchInput.js';
import { QuerySuggestionsSearchInputTrackingProvider } from './base/components/QuerySuggestionsSearchBar/QuerySuggestionsSearchInputTrackingProvider.js';

var SearchBar = function SearchBar(_ref) {
  var children = _ref.children,
    searchLabel = _ref.searchLabel,
    searchPlaceholder = _ref.searchPlaceholder,
    seeAllText = _ref.seeAllText,
    instanceId = _ref.instanceId,
    minCharLength = _ref.minCharLength,
    locale = _ref.locale,
    _ref$applicationName = _ref.applicationName,
    applicationName = _ref$applicationName === void 0 ? SEARCH_BAR_FLYOUT_APPLICATION_NAME : _ref$applicationName,
    resultDisplayConfiguration = _ref.resultDisplayConfiguration,
    _ref$veilEnabled = _ref.veilEnabled,
    veilEnabled = _ref$veilEnabled === void 0 ? true : _ref$veilEnabled,
    _ref$flyoutEnabled = _ref.flyoutEnabled,
    flyoutEnabled = _ref$flyoutEnabled === void 0 ? true : _ref$flyoutEnabled,
    queryString = _ref.queryString,
    resultPlugins = _ref.resultPlugins,
    resultsPageUrl = _ref.resultsPageUrl,
    getResultsPageUrl = _ref.getResultsPageUrl,
    flyoutSiteAnalyticsEventName = _ref.flyoutSiteAnalyticsEventName,
    getFlyoutSiteAnalyticsQueryString = _ref.getFlyoutSiteAnalyticsQueryString,
    enabledAbTests = _ref.enabledAbTests,
    searchedTerm = _ref.searchedTerm,
    auth = _ref.auth,
    logger = _ref.logger;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    experiments = _useState2[0],
    setExperiments = _useState2[1];
  var _useState3 = useState(resultPlugins !== null && resultPlugins !== void 0 ? resultPlugins : []),
    _useState4 = _slicedToArray(_useState3, 2),
    plugins = _useState4[0],
    setResultPlugins = _useState4[1];
  useEffect(function () {
    if (abReader.initialize) {
      abReader.initialize();
    }
    abReader.whenAvailable(function () {
      var experiments = abReader.getAllExperiments();
      var experimentsSet = experiments.map(function (experiment) {
        return {
          Experiment: experiment.experimentKey,
          Variation: experiment.variationKey
        };
      });
      setExperiments(experimentsSet);
    }, 2500);
  }, [abReader.whenAvailable, abReader.getAllExperiments]);
  useEffect(function () {
    if (!resultPlugins && experiments) {
      var hitsPerPage = Math.max.apply(Math, _toConsumableArray(Object.values((resultDisplayConfiguration === null || resultDisplayConfiguration === void 0 ? void 0 : resultDisplayConfiguration.maxResultsPerTaxonomy) || [0]))) || (resultDisplayConfiguration === null || resultDisplayConfiguration === void 0 ? void 0 : resultDisplayConfiguration.maxResults);
      setResultPlugins(FlyoutDefaultResultPlugins(locale, hitsPerPage));
    }
  }, [experiments]);
  return /*#__PURE__*/React__default.createElement(ScreenClassProvider, null, /*#__PURE__*/React__default.createElement(SearchApplication, {
    minCharLength: minCharLength,
    locale: locale,
    queryString: queryString,
    applicationName: applicationName,
    resultPlugins: plugins,
    instanceId: instanceId,
    resultsPageUrl: resultsPageUrl,
    getResultsPageUrl: getResultsPageUrl,
    resultDisplayConfiguration: resultDisplayConfiguration,
    enabledAbTests: enabledAbTests,
    auth: auth,
    logger: logger
  }, applicationName !== HELP_CENTER_APPLICATION_NAME ? /*#__PURE__*/React__default.createElement(QuerySuggestionsSearchInputTrackingProvider, {
    query: searchedTerm,
    applicationName: applicationName !== null && applicationName !== void 0 ? applicationName : SEARCH_BAR_FLYOUT_APPLICATION_NAME,
    logger: logger
  }, /*#__PURE__*/React__default.createElement(QuerySuggestionsSearchInput, {
    locale: locale,
    query: searchedTerm,
    logger: logger,
    searchLabel: searchLabel,
    searchPlaceholder: searchPlaceholder
  })) : /*#__PURE__*/React__default.createElement(OmniSearchInput, {
    searchLabel: searchLabel,
    searchPlaceholder: searchPlaceholder,
    searchedTerm: searchedTerm
  }), flyoutEnabled && /*#__PURE__*/React__default.createElement(ErrorBoundary, {
    logger: logger,
    component: "".concat(applicationName, "-flyout")
  }, /*#__PURE__*/React__default.createElement(SearchFlyout, {
    veilEnabled: veilEnabled,
    minQueryLen: minCharLength,
    siteAnalyticsEventName: flyoutSiteAnalyticsEventName,
    seeAllText: seeAllText,
    getSiteAnalyticsQueryString: getFlyoutSiteAnalyticsQueryString,
    applicationName: applicationName,
    resultDisplayConfiguration: resultDisplayConfiguration
  }), /*#__PURE__*/React__default.createElement(TaxonomyRenderers, null)), children));
};

export { SearchBar as default };
//# sourceMappingURL=SearchBar.js.map
